import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { QUERY_KEYS } from '../../constants/queryKeys';
import { getUserInfo } from '../../api/services/user';
import { LoadingScreen } from '../../components/LoadingScreen';
import { getCurrentSubscription } from '../../api/services/subscriptions';
import styled from 'styled-components';
import { fadeIn } from '../../styles/styles';
import { LanguageSelect } from '../../components/Select/LanguageSelect';
import laptop from '../../assets/laptop.png';
import { lightTheme } from '../../styles/theme';
import Gradient from '../../assets/gradient-bottom.png';
import { useTranslation } from '../../lang/TranslationContext';

export const FinalizeSubscription = () => {
	const { translations } = useTranslation();

	const { data: userMe } = useQuery({
		queryKey: [QUERY_KEYS.userMe],
		queryFn: async () => {
			const response = await getUserInfo();
			if (response.data) {
				return response.data;
			}
		},
	});

	const { data: currentSubscription } = useQuery({
		queryKey: [QUERY_KEYS.currentSubscription],
		queryFn: async () => {
			const response = await getCurrentSubscription();
			if (response.data) {
				return response.data;
			} else {
				return null;
			}
		},
	});

	console.log(currentSubscription);

	if (!userMe) return <LoadingScreen fullScreen />;

	return (
		<Wrap>
			<Top>
				<div>
					<LanguageSelect />
				</div>
			</Top>
			<Middle>
				<h1>{translations.landing.finalize.heading}</h1>
				<p>{translations.landing.finalize.info}</p>
				<ImgWrap>
					<img src={laptop} alt="laptop" />
				</ImgWrap>
				<ButtonWrap>
					<div>
						<i className="pi pi-apple" />
						<div>
							<p>Download app</p>
							<p>For MacOS</p>
						</div>
					</div>
					<div>
						<i className="pi pi-microsoft" id="microsoft" />
						<div>
							<p>Download app</p>
							<p>For Windows</p>
						</div>
					</div>
				</ButtonWrap>
			</Middle>
			<Bottom>
				<img src={Gradient} alt="gradient" />
			</Bottom>
		</Wrap>
	);
};

const Bottom = styled.div`
	position: relative;
	z-index: 1;

	> img {
		bottom: 0;
		right: 0;
		position: fixed;
	}
`;

export const ButtonWrap = styled.div`
	display: flex;
	gap: 54px;

	> div {
		cursor: pointer;
		padding: 8px 16px;
		display: flex;
		align-items: center;
		border-radius: 8px;
		background: ${lightTheme.buttons.fill.background.primary};
		transition: 0.2s;

		&:hover {
			opacity: 0.8;
		}

		i,
		p {
			color: white;
		}

		i {
			font-size: 27px;

			&#microsoft {
				font-size: 23px;
			}

			@media screen and (max-width: 425px) {
				font-size: 23px;

				&#microsoft {
					font-size: 20px;
				}
			}
		}

		> div {
			margin-left: 10px;
			display: flex;
			flex-direction: column;

			p {
				margin: 0;
				width: fit-content;

				&:nth-of-type(1) {
					font-weight: 400;
					font-size: 12px;
				}
				&:nth-of-type(2) {
					font-weight: 600;
					font-size: 16px;
				}

				@media screen and (max-width: 425px) {
					&:nth-of-type(1) {
						font-size: 10px;
					}
					&:nth-of-type(2) {
						font-weight: 600;
						font-size: 14px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 425px) {
		gap: 10px;
	}
`;

const ImgWrap = styled.div`
	margin-top: 70px;
	max-width: 550px;

	img {
		width: 100%;
	}
`;

const Wrap = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	padding-bottom: 70px;
	animation: ${fadeIn} 0.4s;
	padding: 0 30px;
`;

const Top = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	position: relative;
	z-index: 10;

	> img {
		top: 0;
		left: 0;
		position: fixed;
	}

	> div {
		z-index: 3;
		margin: 24px -6px 0 0;

		@media screen and (max-width: 850px) {
			margin: 14px -16px 0 0;
		}
	}
`;

const Middle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	z-index: 3;

	h1 {
		font-size: 36px;
		font-weight: 600;
		text-align: center;
		color: ${lightTheme.typography.success};

		@media screen and (max-width: 850px) {
			margin-top: 70px;
		}
		@media screen and (max-width: 425px) {
			font-size: 28px;
		}
	}

	p {
		margin-top: 24px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: ${lightTheme.typography.secondary};
		max-width: 680px;
	}
`;
